const primaryPin = require("../../../../maps/images/pins/pins_clean/primary_pin.svg");
const pastelGreenPin = require("../../../../maps/images/pins/pins_clean/pastel_green_pin.svg");
const pastelOrangePin = require("../../../../maps/images/pins/pins_clean/pastel_orange_pin.svg");

export const getOfferMarkerIcon = (isFavourite: boolean, hasBeenLead: boolean) => {
    if (hasBeenLead) {
        return pastelGreenPin;
    }

    if (isFavourite) {
        return pastelOrangePin;
    }

    return primaryPin;
};
const primaryPin = require("../../../../maps/images/pins/pins_clean/primary_pin.svg");
const pastelGreenPin = require("../../../../maps/images/pins/pins_clean/pastel_green_pin.svg");
const pastelOrangePin = require("../../../../maps/images/pins/pins_clean/pastel_orange_pin.svg");

export const getOfferMarkerIcon = (isFavourite: boolean, hasBeenLead: boolean) => {
    if (hasBeenLead) {
        return pastelGreenPin;
    }

    if (isFavourite) {
        return pastelOrangePin;
    }

    return primaryPin;
};
